import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { fetchReputation } from '../../store/slices/reputationSlice';
import { fetchLoyalty } from '../../store/slices/loyaltySlice';
import StatsCard from './StatsCard';
import ReputationChart from './ReputationChart';
import TokenBalance from './TokenBalance';
import BadgesDisplay from './BadgesDisplay';
import ActivityTimeline from './ActivityTimeline';

const ImpactDashboard: React.FC = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const { score, level } = useAppSelector((state) => state.reputation);
  const { balance } = useAppSelector((state) => state.loyalty);

  useEffect(() => {
    dispatch(fetchReputation());
    dispatch(fetchLoyalty());
  }, [dispatch]);

  // These would come from a separate impact endpoint
  const impactStats = {
    projectsCreated: 0,
    votesCast: 0,
    commentsAdded: 0,
    participation: 0,
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatsCard
          title="Projects Created"
          value={impactStats.projectsCreated}
          icon="📝"
        />
        <StatsCard
          title="Votes Cast"
          value={impactStats.votesCast}
          icon="🗳️"
        />
        <StatsCard
          title="Comments"
          value={impactStats.commentsAdded}
          icon="💬"
        />
        <StatsCard
          title="Participation"
          value={impactStats.participation}
          icon="🎯"
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ReputationChart />
        <TokenBalance />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <BadgesDisplay />
        <ActivityTimeline />
      </div>
    </div>
  );
};

export default ImpactDashboard;

